// extracted by mini-css-extract-plugin
export default {"text03":"WorkHours_text03__3pJZo","maxHoursError":"WorkHours_maxHoursError__3kUsO","stats":"WorkHours_stats__3c64t","stat":"WorkHours_stat__2FSGy"};